export const GmbAttributeValueType = {
  BOOL: 1,
  ENUM: 2,
  URL: 3,
  REPEATED_ENUM: 4
};
